// extracted by css-extract-rspack-plugin
export default {"spaceNone":"0px","spaceMedium":"20px","spaceLarge":"32px","gridRow":"Grid-module__gridRow___o0YBc","gridColumn":"Grid-module__gridColumn___l6HSw"};